import { MappedImage } from "src/utils/fw"

const links = [
    {
        label: "What's coming up in the ISF?",
        href: "https://interactive.isflive.org/member/whats-coming-up",
        width: "39%",
        height: "5%",
        left: "11%",
        top: "67.5%"
    },
    {
        label: "Join your local chapter",
        href: "https://www.isflive.org/s/chapters",
        width: "39%",
        height: "5%",
        left: "50.5%",
        top: "67.5%"
    },
    {
        label: "Get started on ISF Live",
        href: "https://www.isflive.org/s/get-started",
        width: "39%",
        height: "5%",
        left: "11%",
        top: "73%"
    },
    {
        label: "Making the most of your ISF Membership",
        href: "https://www.isflive.org/s/contentdocument/0696M00000PjG05QAF",
        width: "39%",
        height: "5%",
        left: "50.5%",
        top: "73%"
    },
    {
        label: "Get in touch with your account manager",
        href: "https://www.isflive.org/s/contact-us",
        width: "42.3%",
        height: "5%",
        left: "29%",
        top: "81.8%"
    }
].map(it => ({...it, target: "_blank"}))

export default [
    () => <MappedImage links={links} imageStyle="width:unset;" imageURL="https://assets.swoogo.com/uploads/full/4566360-671816b2cd210.png">
        <iframe src="https://player.vimeo.com/video/850505571?autoplay=1" allowfullscreen style={{
            top: "15.9%",
            left: "11.1%",
            width: "78.3%",
            height: "48.8%",
            position: "absolute",
            border: 0
        }} allow="autoplay" />
    </MappedImage>,
    {
        name: "Maximize your Memberhsip",
        dismiss: {
            width: "2%",
            height: "3%",
            left: "87.5%",
            top: "10.5%"
        }
    }
]
